import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItems } from 'src/app/administracion/menuItems';
import { NavService } from './nav.service';
import { NetsolinService } from './netsolin.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  vista = "erp"
  public instruccionS: Subject<any>
  public instruccionP: Subject<any>

  constructor(public navServices: NavService) {
    this.instruccionP = new Subject();
    this.instruccionS = new Subject();
  }

  postInstructionS(ins) {
    this.instruccionS.next(ins)
  }
  postInstructionP(ins) {
    this.instruccionP.next(ins)
  }

  collapseUserSidebar() {
    this.navServices.collapseUserSidebar = !this.navServices.collapseUserSidebar
    document.getElementsByTagName("html")[0].classList.toggle("less")
    console.log(document.getElementsByTagName("html")[0]);
  }

  collapseUserSidebarClose() {
    this.navServices.collapseUserSidebar = true
    document.getElementsByTagName("html")[0].classList.toggle("less")
    console.log(document.getElementsByTagName("html")[0]);
  }

  collapseUserSidebarOpen() {
    this.navServices.collapseUserSidebar = false
    document.getElementsByTagName("html")[0].classList.toggle("less")
    console.log(document.getElementsByTagName("html")[0]);
  }


}
